import React from 'react';

const PleaseWait = ({show}) => {
    if (!show) {
        return null;
    }

    return (
        <div>
            <i className="fa fa-fw fa-spin fa-spinner"></i> {window.__js_general.please_wait}
        </div>
    );
}

export default PleaseWait;